import $ from 'jquery';

module.exports = {
    base: '/the-list/',

    get (fn, url = '') {
        $.ajax(`${this.base}api${url}?format=json`)
            .then(function (data) {
                fn(data);
            }, function (data) {
                console.error('Error retrieving data', data.statusText);
            });
    }
};



// WEBPACK FOOTER //
// ./assets/js/thelist/api.js